// src/components/Features.jsx
import React from 'react';

const Features = () => (
    <section id="features" className="features">
        <div className="container">
            <h2 className="section-title">Why Choose Zenzzz?</h2>
            <div className="features-grid">
                <div className="feature-card">
                    <div className="feature-icon">🌿</div>
                    <h3>Naturally Powerful</h3>
                    <p>Valerian root, chamomile, magnesium, glycine and l-theanine chosen to help your body truly unwind.
                        <br />
                        <em>Fall asleep fast. Wake up clear.</em>
                    </p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">⏱️</div>
                    <h3>Feel it from Night One</h3>
                    <p>Most feel calmer within an hour and sleep deeper that night.
                        <br />
                        <em>you will body will thank you the next day.</em></p>
                </div>
                <div className="feature-card">
                    <div className="feature-icon">🔒</div>
                    <h3>Rooted in Science</h3>
                    <p>Formulated by sleep experts using research-backed dosages.
                        <br />
                        <em>Real rest, made for real life.</em></p>
                </div>
            </div>
        </div>
    </section>
);

export default Features;